if (!customElements.get('spika-newsletter-wrapper')) {
  customElements.define('spika-newsletter-wrapper', class SpikaNewsletterWrapper extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.addEventListener('click', this.clickHandler.bind(this));
      this.form.addEventListener('submit', this.submitHandler.bind(this));

      this.spikaRegistered = false;
    }

    clickHandler(e) {
      if (window.SPOTLIGHT) {
        this.spikaRegistered = true;
        window.SPOTLIGHT.registerNewsletter();
        console.log('SPOTLIGHT executed')
      } else {
        console.warn('SPOTLIGHT is not defined');
        this.form.classList.remove('pointer-events-none-child')
      }
    }

    submitHandler(e) {
      if (this.spikaRegistered) {
        e.preventDefault();
      }
    }
  });
}
